import React, { PropTypes, Component } from 'react';
import R from 'ramda';
import { Checkbox, Card, CardHeader, CardText, TextField, FontIcon } from 'material-ui';
import { fromJS } from 'immutable';
import pluralize from 'pluralize';
const isNilOrEmpty = R.either(R.isNil, R.isEmpty);

const propTypes = {
  updateProps: PropTypes.func,
  checkLocation: PropTypes.func,
  checkAllLocations: PropTypes.func,
  checkProduct: PropTypes.func,
  isAccom: PropTypes.bool,
  isSingleLoc: PropTypes.bool,
  hasAccessToCreateLoc: PropTypes.bool,
  style: PropTypes.object,
  locations: PropTypes.arrayOf(PropTypes.shape({
    locationId: PropTypes.string,
    name: PropTypes.string,
    contactInfoComplete: PropTypes.bool,
    contactInfo: PropTypes.shape({
      address: PropTypes.shape({
        postal_code: PropTypes.string,
        country: PropTypes.string,
        address_1: PropTypes.string,
        address_2: PropTypes.string,
        city: PropTypes.string,
        state: PropTypes.string,
      }),
      phone: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
    }),
    products: PropTypes.arrayOf(PropTypes.shape({
      productId: PropTypes.string,
      name: PropTypes.string,
      checked: PropTypes.bool,
    })),
    access: PropTypes.arrayOf(PropTypes.string),
    checked: PropTypes.bool,
  })).isRequired,
};
class SelectLocationsProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCreateLocTF: !props.isSingleLoc,
    };
  }
  toToggleShowTF = () => this.setState({ showCreateLocTF: !this.state.showCreateLocTF })
  render() {
    const {
      updateProps,
      checkLocation,
      checkAllLocations,
      checkProduct,
      isAccom,
      isSingleLoc,
      hasAccessToCreateLoc,
      style,
      locations,
    } = this.props;

    const containerStyle = {
      borderRadius: '2px',
      border: '1px solid #e0e0e0',
      ...style,
    };
    const selectedLocs = R.filter(R.both(R.propEq('checked', true), loc => loc.name), (locations || []));
    const allChecked = R.all(R.either(R.propEq('checked', true), loc => !loc.name))(locations || []);

    const updateLocationProps = R.curry((locationIndex, updater) => {
      const immutableNewLocs = fromJS(locations).update(locationIndex, location => location.merge(fromJS(updater)));
      updateProps({ locations: immutableNewLocs.toJS() });
    });

    if (isSingleLoc) {
      return <div/>;
    }
    return (
      <div>
        <label><b>Please select the properties/locations you would like to create templates for:</b></label> <span style={{ color: 'red' }}>* Required</span>
        <div style={containerStyle}>
          {
            locations && locations.length > 1 ? (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Checkbox
                  label="Select All"
                  checked={allChecked}
                  disabled={locations.some(loc => loc.locationId && !R.contains('write', loc.access || []))}
                  style={{ marginTop: '8px', fontWeight: 'bold', width: '50%' }}
                  onCheck={() => checkAllLocations(!allChecked)}
                />
                <span>{selectedLocs.length} property(s)/location(s) selected</span>
              </div>) : <span/>
          }
          {
            locations.map((location, locationIndex) => {
              const numProductsChecked = location.products ? location.products.filter(R.prop('checked')).length : 0;
              if (location.locationId) {
                return (
                  <Card
                    key={location.locationId}
                    style={{ boxShadow: '0' }}
                  >
                    <CardHeader
                      actAsExpander
                      showExpandableButton={!isNilOrEmpty(location.products)}
                      style={{ fontWeight: 'normal', padding: '8px 8px 8px 16px', height: '48px' }}
                    >
                      <Checkbox
                        label={<div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          {location.name}
                          {
                            !isNilOrEmpty(location.products) && <small>{`${numProductsChecked} ${pluralize('products', numProductsChecked)} selected`}</small>
                          }
                        </div>}
                        disabled={!R.contains('write', location.access)}
                        checked={location.checked}
                        labelStyle={{ textOverflow: 'ellipsis', overflowX: 'hidden', whiteSpace: 'nowrap' }}
                        style={{ bottom: '16px', width: '80%' }}
                        onCheck={() => checkLocation(locationIndex, !location.checked)}
                      />
                    </CardHeader>
                    {
                      !isNilOrEmpty(location.products) && (
                        <CardText expandable style={{ paddingLeft: '52px', marginBottom: '12px', padding: '8px 8px 8px 16px' }}>
                          {
                            location.products.map((product, productIndex) => (
                              <Checkbox key={productIndex} label={product.name} checked={product.checked} onCheck={() => checkProduct(locationIndex, productIndex, !product.checked)} />
                            ))
                          }
                        </CardText>
                      )
                    }
                  </Card>
                );
              }
              const duplicateLocName = R.call(R.compose(
                R.any(R.compose(R.lt(1), R.length)),
                R.values,
                R.groupBy(R.prop('name'))
              ), locations);
              return (
                <div
                  key={`newlocName${locationIndex}`}
                >
                  <div
                    style={{ fontWeight: 'normal', padding: '8px 8px 8px 16px', height: '48px', display: 'flex', alignItems: 'center' }}
                  >
                    <Checkbox
                      checked={Boolean(location.name) || locations.length === 1}
                      disabled={!Boolean(location.name)}
                      style={{ width: '44px' }}
                      onCheck={() => {
                        updateLocationProps(locationIndex, { name: '', products: [] });
                      }}
                    />
                    <TextField
                      id={`newlocName${locationIndex}`}
                      defaultValue={location.name}
                      hintText={`Enter a new ${isAccom ? 'property' : 'location'} name here...`}
                      errorText={duplicateLocName ? `Duplicate with another ${isAccom ? 'property' : 'location'}` : ''}
                      onChange={(_, val) => {
                        updateLocationProps(locationIndex, { name: val, checked: Boolean(val) });
                      }}
                    />
                  </div>
                </div>
              );
            })
          }
          {
            !isSingleLoc && R.last(locations).name && (
              <div
                style={{ margin: '12px 0 18px 18px' }}
                className="add-item-card-flex"
                onClick={() => {
                  updateProps({ locations: R.append({ name: '', products: [] }, locations) });
                }}
              >
                <div style={{ border: `1px dashed #00bcd4`, height: '20px', width: '20px', display: 'inline-block' }} >
                  <FontIcon style={{ verticalAlign: 'middle', color: '#00bcd4', fontSize: '18px', marginTop: '-5px' }} className="tc-icon-add" />
                </div>
                <span style={{ marginLeft: '18px', color: '#00bcd4', display: 'inline-block', verticalAlign: 'middle' }}>
                      {`Create a new ${isAccom ? 'property' : 'location'}`}
                    </span>
              </div>
            )
          }
        </div>
      </div>
    );
  }
}

SelectLocationsProducts.propTypes = propTypes;

export default SelectLocationsProducts;



// WEBPACK FOOTER //
// ./src/app/components/contracting/dummy-account/create-dummy-templates-wizard/select-locations-products.jsx